import * as Actions from 'reducks/calendar/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const CalendarReducer = (state = initialState.calendar, action: any) => {
  switch (action.type) {
    case Actions.FETCH_SPECIAL_HOLIDAYS:
      return {
        ...state,
        specialHolidays: [...action.payload],
      }
    case Actions.INIT_CALENDAR:
      return {
        ...initialState.calendar,
        specialHolidays: [...state.specialHolidays],
      }
    case Actions.SET_ACTIVE_DATES:
      return {
        ...state,
        activeDates: [...action.payload],
      }
    case Actions.SET_CURRENT_DATE:
      return {
        ...state,
        currentDate: action.payload,
      }
    case Actions.SET_CURRENT_MONTH:
      return {
        ...state,
        currentMonth: action.payload,
      }
    case Actions.SET_CLOSED_DATES:
      return {
        ...state,
        closedDates: [...action.payload],
      }
    case Actions.SET_ORDERED_DATES:
      return {
        ...state,
        orderedDates: [...action.payload],
      }
    default:
      return state
  }
}
